// base
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// types
import { SettingsCollection } from '../../interfaces/types'
// constants
import { FetchStatus } from '../../config/configuration'
 
export interface SettingsState {
    readonly settingsCollection: SettingsCollection
    readonly status: FetchStatus | null
    readonly error: string | null
}
 
const initialState: SettingsState = {
  settingsCollection: {
    calendar: [],
    quickLinks: [],
    announcements: [],
    pointsOfContact: [],
    knowledgegraphs: [],
    reviewMeetingSchedule: [],
    qanda: [],
    helpdesk: [],
    sitefeedback: [],
    tooltips: [],
    policyMemo: [],
    siteFeedbackAbout: [],
    bannertext: [],
    logo:[],
    releaseNotes: []
  },
  status: null,
  error: null
}
export const getAllSettings = createAsyncThunk(
  'settings/getAllSettings',
  async () => {
    // TODO: settingsAPI has been removed - this now returns empty data
    // Consider migrating to RTK Query (store/settings/api.ts) instead
    return {
      announcements: [],
      knowledgeGraph: [],
      pointOfContact: [],
      quickLinks: [],
      qandA: [],
      releaseNotes: []
    }
  }
)
 
const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSettings.pending, (state) => {
        state.status = FetchStatus.LOADING
      })
      .addCase(getAllSettings.fulfilled, (state, action) => {
        state.status = FetchStatus.SUCCESS
        if (action.payload) {
          state.settingsCollection = {
            ...state.settingsCollection,
            ...action.payload
          }
        }
      })
      .addCase(getAllSettings.rejected, (state, action) => {
        state.status = FetchStatus.FAILED
        state.error = action.error.message ?? null
      })
  }
})
// eslint-disable-next-line no-empty-pattern
export const { } = settingsSlice.actions
export default settingsSlice.reducer